module.exports = __webpack_public_path__ + "static/img/FrequencyCard.0c554a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FrequencyCard.jpg
// module id = 1247
// module chunks = 1